import { Injectable } from '@angular/core';
import { SessionService } from '../../shared/session-service/session.service';

import { ICreateBusinessComponentRequest, IGetBCSAndStandaloneCpsResponse, IUpdateBusinesComponentTagging, ProjectsAndBusinessComponents } from './models/business-component.model';
import { AddExistingClientProjectRequest, DeleteProjectRequest, IDeleteClientProject, RemoveProjectFromBCRequest } from './models/client-project.model';

import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';
import { Project } from '../../shared/models/project.model';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { ClientProject } from './models/client-project.model';
import { BusinessComponentDetail } from './models/client-project.model';
import { RightSideDrawerService } from '../../shared/right-side-drawer/right-side-drawer.service';
import { LoadingIndicatorService, ToastrService } from '@kpmg-tax/ui';
import { ProjectAndBusinessComponentsDTO } from './models/business-component.model';
import { HttpClient } from '@angular/common/http';
import { BusinessComponentsProjectsDTO, BusinessComponentsProjectsResponseDTO, ClientProjectsDTO, ProjectSurveys } from './models/business-component-response.model';
import { ActivatedRoute } from '@angular/router';
import { APP_CONSTANTS } from 'src/app/shared/constants/app-constants';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { FileImportStatus } from 'src/app/shared/models/file-import-status.model';
import { encodeText } from 'src/app/shared/lib/custom-tools';

@Injectable({ providedIn: 'root' })
export class BusinessComponentService {
    engagementID: number;
    initialCount: number;
    private projectsTableRefreshSubject = new BehaviorSubject<boolean>(false);
    addDrawer = new BehaviorSubject({});
    enableAddDrawer = this.addDrawer.asObservable();
    refreshProjects$ = this.projectsTableRefreshSubject.asObservable();
   public uploaded:boolean=false;

    private businessComponentNamesSubject = new BehaviorSubject<BusinessComponentDetail[]>([])
    businessComponentData$ = this.businessComponentNamesSubject.asObservable();
    private initialProjectAndBusinessComponentsState: ProjectAndBusinessComponentsDTO = {
        clientProjects: [],
        businessComponents: [],
        projectSurveys: []
    };
    private projectAndBusinessComponentsSubject = new BehaviorSubject<ProjectAndBusinessComponentsDTO>(this.initialProjectAndBusinessComponentsState);
    projectAndBusinessComponents$ = this.projectAndBusinessComponentsSubject.asObservable();

    clientProjectsCopy: ClientProject[];
    selected: ClientProject[] = [];
    public clientProjectsCount$: Observable<number>;

    //Initial response
    private businessComponentsprojectsSubject = new BehaviorSubject<BusinessComponentsProjectsDTO[]>([]);
    businessComponentsprojects$ = this.businessComponentsprojectsSubject.asObservable();
    private projectSurveysSubject = new BehaviorSubject<ProjectSurveys[]>([]);
    projectSurveys$ = this.projectSurveysSubject.asObservable();
    private fileImportStatusSubject = new BehaviorSubject<FileImportStatus>({ fileType: 0, importStatus: 0 });
    fileImportStatus$ = this.fileImportStatusSubject.asObservable();
    constructor(private sessionService: SessionService, public rightSideDrawerService: RightSideDrawerService,
        private _toasterService: ToastrService, private httpClient: HttpClient, private _loader: LoadingIndicatorService
    ) {

    }

    addProject(newProject: ClientProjectsDTO) {
        // Get the current list of business components
        const existingComponents = this.businessComponentsprojectsSubject.getValue();

        const bcIndex = existingComponents.findIndex(x => x.businessComponentId === newProject.businessComponentId);

        if (bcIndex !== -1) {

            const updatedComponent = {
                ...existingComponents[bcIndex],
                clientProjectsDTOs: [...existingComponents[bcIndex].clientProjectsDTOs, newProject]
            };


            const updatedComponents = [
                ...existingComponents.slice(0, bcIndex),
                updatedComponent,
                ...existingComponents.slice(bcIndex + 1)
            ];


            this.businessComponentsprojectsSubject.next(updatedComponents);
        } else {
            const nullBcIndex = existingComponents.findIndex(x => x.businessComponentId === null);

            if (nullBcIndex !== -1) {
                const updatedComponent = {
                    ...existingComponents[nullBcIndex],
                    clientProjectsDTOs: [...existingComponents[nullBcIndex].clientProjectsDTOs, newProject]
                };

                const updatedComponents = [
                    ...existingComponents.slice(0, nullBcIndex),
                    updatedComponent,
                    ...existingComponents.slice(nullBcIndex + 1)
                ];

                this.businessComponentsprojectsSubject.next(updatedComponents);
            } else {
                const defaultComponent: BusinessComponentsProjectsDTO = {
                    businessComponentId: null,
                    businessComponentName: null,
                    businessComponentQPercentage: 0,
                    bcNumber: null,
                    bcType: null,
                    isAllocated:false,
                    clientProjectsDTOs: [newProject]
                };

                // Add the default component to the list
                const updatedComponents = [...existingComponents, defaultComponent];

                // Emit the updated list through the BehaviorSubject
                this.businessComponentsprojectsSubject.next(updatedComponents);
            }
        }
    }

    //to do
    deleteProject(projectId: number): void {
        // const updatedData = this.projectData.filter(project => project.projectId !== projectId);
        // this.projectData = updatedData;
        // Update BC
    }


    showAddDrawer() {
        this.addDrawer.next(true);
    }
    triggerRefresh(): void {
        this.projectsTableRefreshSubject.next(true);
        this.uploaded=true;
    }
    resetRefresh():void{
        this.uploaded=false;
        this.projectsTableRefreshSubject.next(false);
    }
    fetchProjectsAndBusinessComponents(engagementId: number): Observable<void> {
        //this._loader.display(true);
        return this.sessionService.apiUrlGet(API_URL.GETPROJECTSANDBUSINESSCOMPONENTS + '?engagementId=' + engagementId)
            .pipe(
                map((data: BusinessComponentsProjectsResponseDTO) => {

                    const businessComponentProjects = data.businessComponentsProjectsDTOs;
                    const projectSurveys = data.projectSurveys;
                    this.businessComponentsprojectsSubject.next(businessComponentProjects);
                    this.projectSurveysSubject.next(projectSurveys);
                    this.fileImportStatusSubject.next(data.fileImportStatus);

                }),

            );
    }

    getCurrentFileImportStatus(): FileImportStatus {
        return this.fileImportStatusSubject.getValue();
    }

    addClientProject(addProject: Project): Observable<any> {
        return this.sessionService.apiUrlPost(API_URL.ADDPROJECT, addProject)

    }

    updateClientProject(updateClientProject: Project): Observable<any> {
        return this.sessionService.apiUrlPost(API_URL.UPDATECLIENTPROJECT, updateClientProject)
    }

    getLegalEntitiesForProject(projectId: number, engagementId: number): Observable<any> {
        return this.sessionService.apiUrlGet(API_URL.GETLEGALENTITIESFORPROJECT + '?projectId=' + projectId +
            '&engagementId=' + engagementId,);
    }

    updateBusinessCompDetails(updateBusinessCompDetail: BusinessComponentDetail, engagementId: number): Observable<any> {
        const requestPayload = {
            businessComponentId: updateBusinessCompDetail.businessComponentId,
            businessComponentName:encodeText(updateBusinessCompDetail.businessComponentName),
            businessComponentQPercentage: updateBusinessCompDetail.businessComponentQPercentage,
            businessComponentNumber: updateBusinessCompDetail.bcNumber,
            businessComponentType: updateBusinessCompDetail.bcType,
            engagementId: engagementId
        };
        return this.sessionService.apiUrlPost(API_URL.UPDATEBUSINESSCOMPDETAIL, requestPayload).pipe(
            tap(() => {
                this.updateBusinessComponentModel(updateBusinessCompDetail);
                this._toasterService.setSuccessMessage('Details Updated Successfully');
            }),
            catchError(error => {
                this._toasterService.setErrorMessage('Failed to update details');
                return of(error);
            })
        );
    }

    deleteBusinessComponent(deleteProjectRequest: DeleteProjectRequest): Observable<any> {
        return this.sessionService.apiUrlPost(API_URL.DELETEBUSINESSCOMP, deleteProjectRequest).pipe(
            tap(() => {
                this.updateBusinessComponentList(deleteProjectRequest.projectId);
                this._toasterService.setSuccessMessage('Business component deleted successfully');
            }),
            catchError(error => {
                this._toasterService.setErrorMessage('Failed to delete business component');
                return of(error);
            })
        );
    }

    removeProjectFromBusinessComponent(deleteProjectRequest: RemoveProjectFromBCRequest): Observable<any> {
        return this.sessionService.apiUrlPost(API_URL.REMOVEPROJFROMBIZCOMP, deleteProjectRequest).pipe(
            tap(() => {
                this.fetchProjectsAndBusinessComponents(deleteProjectRequest.engagementId).subscribe();
                this._toasterService.setSuccessMessage('Project removed successfully');
            }),
            catchError(error => {
                this._toasterService.setErrorMessage('Failed to remove project');
                return of(error);
            })
        );
    }

    private updateBusinessComponentModel(updatedDetail: BusinessComponentDetail): void {

        const currentComponents = this.businessComponentsprojectsSubject.getValue();


        const updatedComponents = currentComponents.map(component =>
            component.businessComponentId === updatedDetail.businessComponentId ?
                { ...component, ...updatedDetail } :
                component
        );

        // Update the BehaviorSubject with the new array
        this.businessComponentsprojectsSubject.next(updatedComponents);
    }

    public updateBCQualifiedPercentage(businessComponentIds: number[], qPercentage: number, engagementId: number): Observable<any> {
        businessComponentIds = businessComponentIds.filter(id => id !== null && id !== undefined);
        const requestPayload = {
            businessComponentIds: businessComponentIds,
            bCQualifiedPercentage: qPercentage,
            engagementId: engagementId
        };

        return this.sessionService.apiUrlPost(API_URL.UPDATEBCQUALIFIEDPERCENTAGE, requestPayload).pipe(
            tap(() => {
                const currentComponents = this.businessComponentsprojectsSubject.getValue();
                const updatedComponents = currentComponents.map(component =>
                    businessComponentIds.includes(component.businessComponentId)
                        ? { ...component, businessComponentQPercentage: qPercentage }
                        : component
                );

                // Update the BehaviorSubject with the new array
                this.businessComponentsprojectsSubject.next(updatedComponents);
            })
        );
    }

    public updateCPQualifiedPercentage(businessComponentIds: number[], clientProjectIds: number[], qPercentage: number, engagementId: number): Observable<any> {
        const requestPayload = {
            clientProjectIds: clientProjectIds,
            cPQualifiedPercentage: qPercentage,
            EngagementId: engagementId
        };
        return this.sessionService.apiUrlPost(API_URL.UPDATECPQUALIFEIDPERCENTAGE, requestPayload).pipe(
            tap(() => {
                const currentComponents = this.businessComponentsprojectsSubject.getValue();
                const updatedComponents = currentComponents.map(component =>
                    businessComponentIds.includes(component.businessComponentId)
                        ? {
                            ...component,
                            clientProjectsDTOs: component.clientProjectsDTOs.map(cp =>
                                clientProjectIds.includes(cp.projectId)
                                    ? { ...cp, projectQPercentage: qPercentage }
                                    : cp
                            )
                        }
                        : component
                );

                // Update the BehaviorSubject with the new array
                this.businessComponentsprojectsSubject.next(updatedComponents);
            })
        );


    }

    private updateBusinessComponentList(businessComponentId: number): void {
        const currentComponents = this.businessComponentsprojectsSubject.getValue();
        const targetComponentIndex = currentComponents.findIndex(component => component.businessComponentId === businessComponentId);
        let projectsToMove = [];

        if (targetComponentIndex !== -1) {
            projectsToMove = currentComponents[targetComponentIndex].clientProjectsDTOs.map(clientProject => ({
                ...clientProject,
                businessComponentId: null
            }));
        }

        const updatedComponents = currentComponents.filter(component => component.businessComponentId !== businessComponentId);
        let nullBusinessComponentIndex = updatedComponents.findIndex(component => component.businessComponentId === null);
        if (nullBusinessComponentIndex === -1) {
            const newNullComponent: BusinessComponentsProjectsDTO = {
                businessComponentId: null,
                businessComponentName: null,
                businessComponentQPercentage: 0,
                bcNumber: null,
                bcType: null,
                isAllocated:false,
                clientProjectsDTOs: []
            };
            updatedComponents.push(newNullComponent);
            nullBusinessComponentIndex = updatedComponents.length - 1;
        }
        updatedComponents[nullBusinessComponentIndex].clientProjectsDTOs = updatedComponents[nullBusinessComponentIndex].clientProjectsDTOs.concat(projectsToMove);
        this.businessComponentsprojectsSubject.next(updatedComponents);
    }

    addExistingClientProjects(requestPayload: AddExistingClientProjectRequest): Observable<any> {

        return this.sessionService.apiUrlPost(API_URL.ADDEXISTINGPROJECTTOBIZCOMP, requestPayload).pipe(
            tap(() => {
                this.updateExistingClientProjData(requestPayload.businessComponentId, requestPayload.projectIds);
                this._toasterService.setSuccessMessage('Projects added successfully');
            }),
            catchError(error => {
                this._toasterService.setErrorMessage('Failed to add projects.');
                return of(error);
            })
        );
    }

    private updateExistingClientProjData(businessComponentId: number, projectIds: number[]): void {
        const existingComponents = this.businessComponentsprojectsSubject.getValue();

        const updatedComponents = existingComponents.map(component => {
            const updatedClientProjects = component.clientProjectsDTOs.map(clientProject => ({
                ...clientProject,
                businessComponentId: projectIds.includes(clientProject.projectId) ? businessComponentId : clientProject.businessComponentId
            }));
            return {
                ...component,
                clientProjectsDTOs: updatedClientProjects          
            };
        });

        const nullBusinessComponentIndex = updatedComponents.findIndex(dto => dto.businessComponentId === null);
        if (nullBusinessComponentIndex !== -1) {
            updatedComponents[nullBusinessComponentIndex].clientProjectsDTOs = updatedComponents[nullBusinessComponentIndex].clientProjectsDTOs.filter(
                clientProject => !projectIds.includes(clientProject.projectId)
            );
        }

        const targetBusinessComponentIndex = updatedComponents.findIndex(dto => dto.businessComponentId === businessComponentId);
        if (targetBusinessComponentIndex !== -1) {
            updatedComponents[targetBusinessComponentIndex].clientProjectsDTOs = updatedComponents[targetBusinessComponentIndex].clientProjectsDTOs.concat(
                existingComponents
                    .flatMap(dto => dto.clientProjectsDTOs)
                    .filter(clientProject => projectIds.includes(clientProject.projectId))
                    .map(clientProject => ({
                        ...clientProject,
                        businessComponentId: businessComponentId
                    }))
            );
        } else {

            const newComponent: BusinessComponentsProjectsDTO = {
                businessComponentId: businessComponentId,
                businessComponentName: null,
                businessComponentQPercentage: 0,
                bcNumber: null,
                bcType: null,
                isAllocated:false,
                clientProjectsDTOs: existingComponents
                    .flatMap(dto => dto.clientProjectsDTOs)
                    .filter(clientProject => projectIds.includes(clientProject.projectId))
                    .map(clientProject => ({
                        ...clientProject,
                        businessComponentId: businessComponentId
                    })),

            };

            updatedComponents.push(newComponent);
        }

        this.businessComponentsprojectsSubject.next(updatedComponents);
        this.projectSurveysSubject.next(this.projectSurveysSubject.getValue());
    }

    getStandaloneClientProjects(engagementId: number): Observable<IGetBCSAndStandaloneCpsResponse[]> {
        const apiUrl = `${environment.webApiDefaultRoot}Project/GetStandAloneClientProjects?engagementId=${engagementId}`;
        return this.httpClient.get<IGetBCSAndStandaloneCpsResponse[]>(apiUrl);
    }

    createBusinessComponent(request: ICreateBusinessComponentRequest): Observable<boolean> {
        const apiUrl = `${environment.webApiDefaultRoot}Project/CreateBusinessComponent`;
        const requestBody = request;
        return this.httpClient.post<boolean>(apiUrl, requestBody);
    }

    checkBusinessComponentName(engagementId: number, bcName: string): Observable<boolean> {
        if (bcName.length > 0) {
            const encodedName = btoa(bcName.trim());
            const apiUrl = `${environment.webApiDefaultRoot}Project/IsUniqueBCName?engagementId=${engagementId}&bcName=${encodedName}`;
            return this.httpClient.get<boolean>(apiUrl);
        }
    }

    checkBusinessComponentNumber(engagementId: number, bcNumber: string): Observable<boolean> {
        if (bcNumber.length > 0) {
            const apiUrl = `${environment.webApiDefaultRoot}Project/IsUniqueBCNumber?engagementId=${engagementId}&bcNumber=${bcNumber}`;
            return this.httpClient.get<boolean>(apiUrl);
        }
    }

    UpdateBusinessComponentTagging(request: IUpdateBusinesComponentTagging): Observable<boolean> {
        return this.sessionService.apiUrlPost(API_URL.ADDEXISTINGPROJECTTOBIZCOMP, request).pipe(
            tap(() => {
                this.UpdateBusinessComponentModelTagging(request);
                this._toasterService.setSuccessMessage('Details Updated Successfully');
            }),
            catchError(error => {
                return of(error);
            })
        );
    }

    UpdateBusinessComponentModelTagging(request: IUpdateBusinesComponentTagging) {
        const existingComponents = this.businessComponentsprojectsSubject.getValue();

        const projectsToMove: ClientProjectsDTO[] = [];

        existingComponents.forEach(component => {

            component.clientProjectsDTOs = component.clientProjectsDTOs.filter(project => {
                if (request.projectIds.includes(project.projectId)) {

                    projectsToMove.push({ ...project, businessComponentId: request.businessComponentId });
                    return false;
                }
                return true;
            });
        });

        let targetComponent = existingComponents.find(component => component.businessComponentId === request.businessComponentId);


        targetComponent.clientProjectsDTOs.push(...projectsToMove);
        const updatedComponents = existingComponents.filter(component =>
            component.businessComponentId !== null || component.clientProjectsDTOs.length > 0
        );
        updatedComponents.sort((a, b) => {
            const BCname1 = a.businessComponentName ? a.businessComponentName.trim() : '';
            const BCname2 = b.businessComponentName ? b.businessComponentName.trim() : '';

            if (!BCname1 && !BCname2) return 0;
            if (!BCname1) return 1;
            if (!BCname2) return -1;

            return BCname1.localeCompare(BCname2);
        });

        this.businessComponentsprojectsSubject.next(updatedComponents);
        this.projectSurveysSubject.next(this.projectSurveysSubject.getValue());
    }

    removeClientProjects(deleteClientProjects: IDeleteClientProject): Observable<BaseResponse> {
        const apiUrl = `${environment.webApiDefaultRoot}Project/DeleteClientProjects`;
        const requestBody = deleteClientProjects;
        return this.httpClient.post<BaseResponse>(apiUrl, requestBody).pipe(
            tap((data: BaseResponse) => {
                if (data.success) {
                    this.removeExistingClientProjData(deleteClientProjects.clientProjectIds);
                    this._toasterService.setSuccessMessage('Projects removed successfully');
                }
                else {
                    this._toasterService.setErrorMessage(data.errorMessage);
                }
            }),
            catchError(error => {
                this._toasterService.setErrorMessage('Failed to remove projects.');
                return of(error);
            })
        );;
    }

    removeExistingClientProjData(clientprojects: number[]) {
        const currentProjects = this.businessComponentsprojectsSubject.getValue();
        const updatedProjects = currentProjects.map(businessComponent => {
            return {
                ...businessComponent,
                clientProjectsDTOs: businessComponent.clientProjectsDTOs.filter(
                    project => !clientprojects.includes(project.projectId)
                )
            };
        });

        this.businessComponentsprojectsSubject.next(updatedProjects as BusinessComponentsProjectsDTO[]);
        this.projectSurveysSubject.next(this.projectSurveysSubject.getValue());
    }

    public getImportFileStatus(engagementId) {
        return this.sessionService.apiUrlGet(
            API_URL.GET_IMPORT_FILE_STATUS + '?engagementId=' + engagementId,
        );
    }
}
